export default __webpack_public_path__ + "static/media/bg-map.c516afe1.jpg";